import { Row } from 'hb-react/shared/components/DesignSystem/Grid';
import {
  Email,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import { CardHeader, StyledCol, BillingBlock } from '../Layout';

const PersonalInformation = ({ userFieldsConfig }) => (
  <BillingBlock>
    <CardHeader>{s__('NetworkEvents|Personal information')}</CardHeader>
    <Row>
      <StyledCol>
        <Text
          name="receipt[firstname]"
          label={
            userFieldsConfig?.firstname_label ||
            I18n.t('activerecord.attributes.user.firstname')
          }
          placeholder={
            userFieldsConfig?.firstname_placeholder ||
            I18n.t('activerecord.attributes.user.firstname')
          }
          validate={{ required: true }}
        />
      </StyledCol>
      <StyledCol>
        <Text
          name="receipt[lastname]"
          label={
            userFieldsConfig?.lastname_label ||
            I18n.t('activerecord.attributes.user.lastname')
          }
          placeholder={
            userFieldsConfig?.lastname_placeholder ||
            I18n.t('activerecord.attributes.user.lastname')
          }
          validate={{ required: true }}
        />
      </StyledCol>
    </Row>
    <Row>
      <StyledCol width={({ numCols }) => 6 / numCols}>
        <Email
          name="receipt[email]"
          label={
            userFieldsConfig?.email_label ||
            I18n.t('activerecord.attributes.user.email')
          }
          placeholder={
            userFieldsConfig?.email_placeholder ||
            I18n.t('activerecord.attributes.user.email')
          }
          validate={{ required: true, email: true }}
        />
      </StyledCol>
    </Row>
  </BillingBlock>
);

export default PersonalInformation;
